{
  "nm": "newScene",
  "mn": "",
  "layers": [
    {
      "ty": 0,
      "nm": "Shape Layer 1 Comp 1",
      "mn": "",
      "sr": 1,
      "st": 20,
      "op": 260,
      "ip": 20,
      "hd": false,
      "cl": "",
      "ln": "",
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [200, 150, 0] },
        "s": { "a": 0, "k": [100, 100, 100] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [200, 150, 0] },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [180],
              "t": 30
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [360],
              "t": 71
            }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "ef": [],
      "w": 400,
      "h": 300,
      "refId": "comp_50",
      "ind": 1
    },
    {
      "ty": 0,
      "nm": "Shape Layer 1 Comp 1",
      "mn": "",
      "sr": 1,
      "st": 0,
      "op": 59,
      "ip": 0,
      "hd": false,
      "cl": "",
      "ln": "",
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [200, 150, 0] },
        "s": { "a": 0, "k": [100, 100, 100] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [200, 150, 0] },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [0],
              "t": 19
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [180],
              "t": 59
            }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "ef": [],
      "w": 400,
      "h": 300,
      "refId": "comp_50",
      "ind": 2
    }
  ],
  "ddd": 0,
  "h": 300,
  "w": 400,
  "meta": {
    "a": "",
    "k": "",
    "d": "",
    "g": "@lottiefiles/toolkit-js 0.22.1",
    "tc": "#000000"
  },
  "v": "4.5.7",
  "fr": 60,
  "op": 120,
  "ip": 0,
  "assets": [
    {
      "nm": "",
      "mn": "",
      "layers": [
        {
          "ty": 4,
          "nm": "Shape Layer 1",
          "mn": "",
          "sr": 1,
          "st": 0,
          "op": 240,
          "ip": 0,
          "hd": false,
          "cl": "",
          "ln": "",
          "ddd": 0,
          "bm": 0,
          "hasMask": false,
          "ao": 1,
          "ks": {
            "a": { "a": 0, "k": [-5, 4, 0] },
            "s": { "a": 0, "k": [67.386, 67.386, 100] },
            "sk": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [200, 150, 0] },
            "r": { "a": 0, "k": 0 },
            "sa": { "a": 0, "k": 0 },
            "o": { "a": 0, "k": 100 }
          },
          "ef": [],
          "shapes": [
            {
              "ty": "gr",
              "bm": 0,
              "cl": "",
              "ln": "",
              "hd": false,
              "mn": "ADBE Vector Group",
              "nm": "Ellipse 1",
              "np": 3,
              "it": [
                {
                  "ty": "el",
                  "bm": 0,
                  "cl": "",
                  "ln": "",
                  "hd": false,
                  "mn": "ADBE Vector Shape - Ellipse",
                  "nm": "Ellipse Path 1",
                  "d": 1,
                  "p": { "a": 0, "k": [0, 0] },
                  "s": { "a": 0, "k": [208.5, 208.5] }
                },
                {
                  "ty": "st",
                  "bm": 0,
                  "cl": "",
                  "ln": "",
                  "hd": false,
                  "mn": "ADBE Vector Graphic - Stroke",
                  "nm": "Stroke 1",
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "o": { "a": 0, "k": 100 },
                  "w": { "a": 0, "k": 24 },
                  "d": [],
                  "c": { "a": 0, "k": [0.7608, 0.7843, 0.7608] }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "p": { "a": 0, "k": [-5.5, 4], "ix": 2 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "o": { "a": 0, "k": 100, "ix": 7 }
                }
              ]
            },
            {
              "ty": "tm",
              "bm": 0,
              "cl": "",
              "ln": "",
              "hd": false,
              "mn": "ADBE Vector Filter - Trim",
              "nm": "Trim Paths 1",
              "ix": 2,
              "e": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0.333, "y": 0 },
                    "i": { "x": 0.337, "y": 1 },
                    "s": [0],
                    "t": 0
                  },
                  {
                    "o": { "x": 0.167, "y": 0.167 },
                    "i": { "x": 0.833, "y": 0.833 },
                    "s": [100],
                    "t": 60
                  }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0.333, "y": 0 },
                    "i": { "x": 0.336, "y": 0.99 },
                    "s": [0],
                    "t": 20
                  },
                  {
                    "o": { "x": 0.167, "y": 0.167 },
                    "i": { "x": 0.833, "y": 0.833 },
                    "s": [100],
                    "t": 80
                  }
                ],
                "ix": 1
              },
              "m": 1
            }
          ],
          "ind": 1
        }
      ],
      "id": "comp_50"
    }
  ]
}
